import request from '../../../api/request';
import {
  StudentsRemovalRequestHistoryFiltersResponse,
  StudentsRemovalRequestHistoryResponse,
} from './types/history';
import {
  StudentsRemovalRequestCreateFormResponse,
  StudentsRemovalRequestCreateRequest,
  StudentsRemovalRequestStudentsResponse,
  StudentsRemovalRequestDetailResponse,
} from './types/students';

const STUDENTS_REMOVAL_REQUEST = {
  STUDENTS: `maintainers-portal/student-management/students-removal-request/students`,
  CREATE_FORM: (studyPlanEnrollmentId: number) =>
    `maintainers-portal/student-management/students-removal-request/create/${studyPlanEnrollmentId}`,
  CREATE: (studyPlanEnrollmentId: number) =>
    `maintainers-portal/student-management/students-removal-request/create/${studyPlanEnrollmentId}`,
  HISTORY_FORM: `maintainers-portal/student-management/students-removal-request/history/form`,
  HISTORY: `maintainers-portal/student-management/students-removal-request/history`,
  REQUEST_DETAIL: (studyPlanEnrollmentId: number) =>
    `maintainers-portal/student-management/students-removal-request/detail/${studyPlanEnrollmentId}`,
};

export async function getStudents(params: {
  page: number;
  studentNameOrId?: string;
}) {
  return request<StudentsRemovalRequestStudentsResponse>(
    STUDENTS_REMOVAL_REQUEST.STUDENTS,
    {
      method: 'GET',
      params,
    },
  );
}

export function createStudentRemovalRequestFormData(
  studyPlanEnrollmentId: number,
) {
  return request<StudentsRemovalRequestCreateFormResponse>(
    STUDENTS_REMOVAL_REQUEST.CREATE_FORM(studyPlanEnrollmentId),
  );
}

export function createStudentRemovalRequest(
  studyPlanEnrollmentId: number,
  data: StudentsRemovalRequestCreateRequest,
) {
  return request<any>(STUDENTS_REMOVAL_REQUEST.CREATE(studyPlanEnrollmentId), {
    method: 'POST',
    data,
  });
}

export async function getHistoryForm() {
  return request<StudentsRemovalRequestHistoryFiltersResponse>(
    STUDENTS_REMOVAL_REQUEST.HISTORY_FORM,
    {
      method: 'GET',
    },
  );
}

export async function getHistory(params: {
  page: number;
  studentNameOrId?: string;
  studyPlanVersionId?: number;
  requestState?: string;
}) {
  return request<StudentsRemovalRequestHistoryResponse>(
    STUDENTS_REMOVAL_REQUEST.HISTORY,
    {
      method: 'GET',
      params,
    },
  );
}

export function getRequestDetail(studyPlanEnrollmentId: number) {
  return request<StudentsRemovalRequestDetailResponse>(
    STUDENTS_REMOVAL_REQUEST.REQUEST_DETAIL(studyPlanEnrollmentId),
  );
}
